import styled from 'styled-components/macro';
import { defaultContainer } from '../../../styles/utils';
import {
  OutlineButton,
  PrimaryButton,
  PrimaryButtonLink
} from '../../../components/ButtonStyles';
import { textLinkBase } from '../../../components/LinkStyles';

export const ReferralOptionsBackgroundDiv = styled.div`
  background-color: ${props => props.theme.concrete};
`;

export const ReferralOptionsDiv = styled.div`
  ${defaultContainer}
  padding-top: 9rem;
  padding-bottom: 9rem;
  > h4 {
    margin-bottom: 1rem;
  }
  @media screen and (min-width: 768px) {
    padding: 9rem 3rem;
  }
  @media screen and (min-width: 1024px) {
    padding: 9rem 3rem;
  }
  @media screen and (min-width: 1440px) {
    padding: 9rem 8rem;
  }
`;

export const ReferralOptionItemDiv = styled.div`
  @media screen and (max-width: 767px) {
    &:first-of-type {
      margin-bottom: 33px;
    }
  }
  @media screen and (min-width: 768px) {
    margin-right: 30px;
    width: 48%;
  }
`;

export const ReferralOptionDiv = styled.div`
  background-color: white;
  ${props => props.theme.defaultDropShadow}
  padding: 4rem 3rem;
  margin-bottom: 17px;
  p {
    margin: 1rem 0 1.5rem;
  }
  h4 svg {
    margin-right: 5px;
    transform: translateY(2px);
  }
  & + & {
    margin-top: 1.5rem;
  }
  @media screen and (min-width: 768px) {
    padding: 4rem 2.5rem;
    & + & {
      margin-top: 0;
      margin-left: 1.5rem;
    }
  }
  @media screen and (min-width: 1440px) {
    padding: 4rem;
  }
  ${PrimaryButton} {
    font-weight: 600;
  }
`;

export const ReferralOptionsContainerDiv = styled.div`
  display: flex;
  @media screen and (max-width: 767px) {
    flex-direction: column;
  }
`;

export const ReferralOptionCopyDiv = styled.div`
  ${PrimaryButton} {
    margin-top: 25px;
    padding: 1.5rem;
  }
`;

export const ReferralOptionTitleDiv = styled.div`
  display: flex;
  align-items: center;
  h4 {
    margin-left: 10px;
  }
  span {
    color: ${props => props.theme.blue};
  }
`;

export const ReferralOptionImg = styled.img`
  height: 2.5rem;
`;

export const ReferralOptionButtonLink = styled(PrimaryButtonLink)`
  font-weight: 600;
  @media screen and (min-width: 1024px) {
    width: 250px;
  }
`;

export const ReferralUrlA = styled.a`
  ${textLinkBase}
  padding-bottom: 5px;
  word-wrap: break-word;
  text-decoration: none;
  vertical-align: center;
  line-height: 18px;
  @media screen and (min-width: 1440px) {
    border-bottom: 1px solid ${props => props.theme.mercury};
  }
`;

export const CopyButtonA = styled(OutlineButton)`
  @media screen and (max-width: 767px) {
    margin-top: 1.5rem;
    padding: 1.5rem;
  }
  @media screen and (min-width: 768px) and (max-width: 1023px) {
    border: none;
  }
  @media screen and (min-width: 1024px) {
    margin-left: 1rem;
    padding: 0.5rem;
    transform: translateY(-1px);
    width: auto;
  }

  @media screen and (min-width: 1440px) {
    padding: 0.5rem 1.5rem;
  }
`;
